var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-center"},[_c('div',{staticClass:"border-t py-1 w-2/5",class:'border-' + this.color})])}
var staticRenderFns = []

export { render, staticRenderFns }